import { Backbutton, HeaderState } from './../../models/rootState.model';
import { StoreAction } from '../../models/rootState.model';

// tslint:disable: class-name

export const HEADER_ACTIONS_TYPES = {
  SET_OPTIONS: '[Header] -Set options-',
  RESSET: '[Header] -Resset-',
  START_LOADER: '[Header] -Start Loader-',
  STOP_LOADER: '[Header] -Stop Loader-',
  SHOW: '[Header] -Show header-',
  HIDE: '[Header] -hide header-',

  BACK_BUTTON_CLICKED: '[Header] -Backbutton Clicked-',
  BACK_BUTTON_SET: '[Header SetBackButton] -Backbutton action setted-',

  OPEN_MAIN_MENU: '[Header] -Open main menu-',
  CLOSE_MAIN_MENU: '[Header] -Close main menu-',
  TOGGLE_MAIN_MENU: '[Header] -Toggle main menu-',

  OPEN_SIDE_MENU: '[Header] -Open side menu-',
  CLOSE_SIDE_MENU: '[Header] -Close side menu-',
  TOGGLE_SIDE_MENU: '[Header] -Toggle side menu-',

  DISABLE: '[Header] Disable header',
  ENABLE: '[Header] Enable Header',

  SHOW_ALERTS: '[Header bell] Show alerts',
  CLOSE_ALERTS: '[Header] Close alerts',
  TOGGLE_ALERTS: '[Header bell] Toggle alerts',

  CLOSE_ALL_MENUS: '[Header] -Close all menus-',

  SHOW_CONTEXT_MENU_BUTTON: '[Header] -Show Context menu button-',
  HIDE_CONTEXT_MENU_BUTTON: '[Header] -Hide Context menu button-',

  SET_ELEVATION: '[Header elevation] -Set Header elevation'
};

export class Action_Header_SetOptions implements StoreAction {
  readonly type = HEADER_ACTIONS_TYPES.SET_OPTIONS;
  constructor(public payload: Partial<HeaderState>) { }
}

export class Action_Header_Resset implements StoreAction {
  readonly type = HEADER_ACTIONS_TYPES.RESSET;
  constructor(public payload?: Partial<HeaderState>) {}
}

export class Action_Header_BackButtonSet implements StoreAction<Backbutton> {
  readonly type = HEADER_ACTIONS_TYPES.BACK_BUTTON_SET;
  constructor(public payload: Backbutton) { }
}

export class Action_Header_BackButtonClicked implements StoreAction {
  readonly type = HEADER_ACTIONS_TYPES.BACK_BUTTON_CLICKED;
}

export class Action_Header_StartLoader implements StoreAction {
  readonly type = HEADER_ACTIONS_TYPES.START_LOADER;
}

export class Action_Header_StopLoader implements StoreAction {
  readonly type = HEADER_ACTIONS_TYPES.STOP_LOADER;
}

export class Action_Header_ShowHeader implements StoreAction {
  readonly type = HEADER_ACTIONS_TYPES.SHOW;
}

export class Action_Header_ShowContextMenuButton implements StoreAction {
  readonly type = HEADER_ACTIONS_TYPES.SHOW_CONTEXT_MENU_BUTTON;
}

export class Action_Header_HideContextMenuButton implements StoreAction {
  readonly type = HEADER_ACTIONS_TYPES.HIDE_CONTEXT_MENU_BUTTON;
}

export class Action_Header_HideHeader implements StoreAction {
  readonly type = HEADER_ACTIONS_TYPES.HIDE;
  constructor() { }
}

export class Action_Header_OpenMainMenu implements StoreAction {
  readonly type = HEADER_ACTIONS_TYPES.OPEN_MAIN_MENU;
}

export class Action_Header_CloseMainMenu implements StoreAction {
  readonly type = HEADER_ACTIONS_TYPES.CLOSE_MAIN_MENU;
}

export class Action_Header_ToggleMainMenu implements StoreAction {
  readonly type = HEADER_ACTIONS_TYPES.TOGGLE_MAIN_MENU;
}

export class Action_Header_OpenSideMenu implements StoreAction {
  readonly type = HEADER_ACTIONS_TYPES.OPEN_SIDE_MENU;
}

export class Action_Header_CloseSideMenu implements StoreAction {
  readonly type = HEADER_ACTIONS_TYPES.CLOSE_SIDE_MENU;
}

export class Action_Header_ToggleSideMenu implements StoreAction {
  readonly type = HEADER_ACTIONS_TYPES.TOGGLE_SIDE_MENU;
}

export class Action_Header_CloseAllMenus implements StoreAction {
  readonly type = HEADER_ACTIONS_TYPES.CLOSE_ALL_MENUS;
}

export class Action_Header_DisableMenu implements StoreAction {
  readonly type = HEADER_ACTIONS_TYPES.DISABLE;
}

export class Action_Header_EnableMenu implements StoreAction {
  readonly type = HEADER_ACTIONS_TYPES.ENABLE;
}

export class Action_Header_ShowAlerts implements StoreAction {
  readonly type = HEADER_ACTIONS_TYPES.SHOW_ALERTS;
}

export class Action_Header_CloseAlerts implements StoreAction {
  readonly type = HEADER_ACTIONS_TYPES.CLOSE_ALERTS;
}

export class Action_Header_ToggleAlerts implements StoreAction {
  readonly type = HEADER_ACTIONS_TYPES.TOGGLE_ALERTS;
}

export class Action_Header_SetElevation implements StoreAction<number> {
  readonly type = HEADER_ACTIONS_TYPES.SET_ELEVATION;
  constructor(public payload: number) { }
}
